module.exports = __webpack_public_path__ + "media/images/map-image-f40ed5b1e791e9d2479ba8b5e67f2df8.png";